import React from 'react';
import { useNavigate } from 'react-router-dom';
import CompanyHero from '../components/CompanyHero';
import { COMPANY_ROUTES } from '../constants';

const Companies: React.FC = () => {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate(COMPANY_ROUTES.ONBOARDING);
    };

    return (
        <div className="min-h-screen bg-[#F8F9FB] relative overflow-hidden">
            {/* Background Gradient Layer */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full">
                    <div className="absolute top-1/4 left-1/4 w-[600px] h-[400px] bg-gradient-to-br from-blue-300 via-blue-200 to-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse-slow"></div>
                    <div className="absolute top-1/3 right-1/4 w-[500px] h-[500px] bg-gradient-to-br from-yellow-200 via-orange-200 to-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse-slow" style={{animationDelay: '2s'}}></div>
                    <div className="absolute bottom-1/4 left-1/3 w-[400px] h-[400px] bg-gradient-to-br from-pink-200 via-purple-200 to-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-35 animate-pulse-slow" style={{animationDelay: '4s'}}></div>
                </div>
            </div>
            
            {/* Content Layer */}
            <div className="relative z-10">
                <main>
                    <section className="relative flex items-center justify-center min-h-screen px-4 py-20">
                        <div className="max-w-4xl mx-auto text-center">
                            {/* Use Consolidated Hero Component */}
                            <CompanyHero 
                                title="Welcome to Hush — your smarter way to hire"
                                subtitle="From job posting to first match, our AI does the heavy lifting while you stay in control."
                                showLogo={true}
                            />

                            {/* CTA Button */}
                            <div className="animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                                <button 
                                    onClick={handleGetStarted}
                                    style={{
                                        fontFamily: 'Manrope',
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        color: '#FFFFFF',
                                        background: '#2563EB',
                                        border: 'none',
                                        borderRadius: '12px',
                                        padding: '16px 40px',
                                        cursor: 'pointer',
                                        boxShadow: '0px 8px 24px rgba(37, 99, 235, 0.4)',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#1D4ED8';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0px 12px 32px rgba(37, 99, 235, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#2563EB';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0px 8px 24px rgba(37, 99, 235, 0.4)';
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor"/>
                                    </svg>
                                    Let's get started
                                </button>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default Companies;
